<template>
    <div v-if="isNormaal" class="form-inline">
        <b-col :style="setSizeVal(16)" class="mx-0 px-0 my-0 py-0">
            <b-input-group v-if="!useTimeInput">
                <b-form-timepicker
                    :key="aangeraakt"
                    v-model="localSelected.uitpekelTijd"
                    @input="set_inputTijd"
                    :disabled="!wijzigbaar"
                />
                <cheese-tijd
                    v-model="datumtijd"
                    @change="set_inputUitpekeltijd"
                    :disabled="!wijzigbaar"
                />
            </b-input-group>
            <b-input-group v-if="useTimeInput">
                <b-form-input
                    v-model="localDate"
                    :type="'date'"
                    @blur="setPekeltijd"
                    :disabled="!wijzigbaar"
                ></b-form-input>
                <b-form-input
                    v-model="localTijd"
                    :type="'time'"
                    @blur="setPekeltijd"
                    :disabled="!wijzigbaar"
                ></b-form-input>
            </b-input-group>
        </b-col>

        <b-col :style="setSizeVal(16)" class="mx-0 px-0 my-0 py-0">
            <b-input-group
                :append="$t('com_st', { ns: 'common' })"
                :label="$t('com_stuks', { ns: 'common' })"
            >
                <b-form-input
                    :placeholder="aantKaas"
                    type="number"
                    step="1"
                    v-model.number="localSelected.amount"
                    @change="set_input"
                    :disabled="!wijzigbaar"
                ></b-form-input>
            </b-input-group>
        </b-col>
        <b-col v-if="useWeight" :style="setSizeVal(16)" class="mx-0 px-0 my-0 py-0">
            <b-input-group
                :append="$t('com_kg', { ns: 'common' })"
                :label="$t('com_kilos', { ns: 'common' })"
            >
                <b-form-input
                    :placeholder="weightKaas"
                    type="number"
                    step="0.01"
                    v-model.number="displayKilos"
                    @change="set_input"
                    :disabled="!wijzigbaar"
                ></b-form-input>
            </b-input-group>
        </b-col>
        <b-col style="setSize" class="mx-0 px-0 my-0 py-0">
            <b-form-input
                v-b-tooltip.hover
                :title="maakTekst"
                :disabled="true"
                v-model="maakTekst"
            ></b-form-input>
        </b-col>
        <b-col :style="setSizeVal(16)" class="mx-0 px-0 my-0 py-0">
            <lookup-combo
                v-model="localSelected.stocklocationID"
                v-bind:combotype="lctypeLocation"
                :discrim="pakhuis"
                :disabled="!wijzigbaar"
                @change="set_input"
            ></lookup-combo>
        </b-col>
    </div>
    <div v-else class="form-inline">
        <b-col :style="setSizeVal(16)" class="mx-0 px-0 my-0 py-0">
            <b-input-group
                :append="$t('com_st', { ns: 'common' })"
                :label="$t('com_stuks', { ns: 'common' })"
            >
                <b-form-input
                    :placeholder="aantKaas"
                    type="number"
                    step="1"
                    v-model.number="localSelected.amount"
                    @change="set_input"
                    :disabled="!wijzigbaar"
                ></b-form-input>
            </b-input-group>
        </b-col>
        <b-col :style="setSizeVal(16)" class="mx-0 px-0 my-0 py-0">
            <lookup-combo
                v-model="localSelected.vormID"
                v-bind:combotype="lctypeShapes"
                :disabled="!wijzigbaar"
                @change="set_input"
            ></lookup-combo>
        </b-col>
        <!--         <b-col sm="3" class="mx-0 px-0 my-0 py-0">
            <lookup-combo
                id="input-kaasalternatief"
                v-model="localSelected.uitvalProductNaam"
                v-bind:combotype="lctypeFailure"
                :disabled="!wijzigbaar"
            ></lookup-combo>
        </b-col> -->
        <b-col :style="setSizeVal(25)" class="mx-0 px-0 my-0 py-0">
            <b-form-input
                v-model="localSelected.uitvalProductNaam"
                :disabled="true"
            ></b-form-input>
        </b-col>
        <b-col :style="setSizeVal(25)" class="mx-0 px-0 my-0 py-0">
            <lookup-combo
                v-model="localSelected.stocklocationID"
                :combotype="lctypeLocation"
                :discrim="pakhuis"
                :disabled="!wijzigbaar"
                @change="set_input"
            ></lookup-combo>
        </b-col>
    </div>
</template>
<script>
import { UitpekelItem } from '../../models/BakInfo_helper';
import Helper from '../../models/Helper';
import DateHelper from '../../models/DateHelper';
import { LookupCombo } from './index';
import CheeseTijd from './CheeseTijd';
import { Feature } from '../../models/Features';
import { server } from 'typescript';

export default {
    name: 'UitpekelItemCombo',
    data: function () {
        return {
            lctypeShapes: window.constants.LCSHAPES,
            lctypeCheese: window.constants.LCCHEESE,
            lctypeLocation: window.constants.LCLOCATION,
            lctypeFailure: window.constants.LCFAILURECHEESE,
            pakhuis: window.constants.CHEESESTOCKLOCATION.toString(), // moet string zijn, 10 is kaasopslag
            aangeraakt: 1,
            errorMessage: '',
            eenheidID: null,
            flexList: [],
            localDate: null,
            localTijd: null,
            datumtijd: null
        };
    },
    model: {
        prop: 'selected',
        event: 'input'
    },
    props: {
        selected: {
            type: UitpekelItem,
            required: true
        },
        editAllowed: {
            type: Boolean,
            default: false
        },
        timeInput: {
            type: Boolean,
            default: false
        },
        refresh: {
            type: Number,
            required: false
        },
        baseDateTime: {
            type: Date
        }
    },
    watch: {
        refresh() {
            this.forceRefesh();
        }
    },
    components: {
        LookupCombo,
        CheeseTijd
    },
    computed: {
        wijzigbaar() {
            return this.editAllowed && !this.localSelected.isAlGebruikt;
        },
        useTimeInput() {
            if (this.timeInput) {
                return false;
            }
            return !this.checkFeature('conf_UseDateTimePicker');
        },
        aantKaas() {
            return Helper.stringformat(
                '{0} {1}',
                this.$t('com_number', { ns: 'common' }),
                this.$t('com_kazen', { ns: 'common' }).toLowerCase()
            );
        },
        weightKaas() {
            return Helper.stringformat(
                '{0} {1}',
                this.$t('com_weight', { ns: 'common' }),
                this.$t('com_kazen', { ns: 'common' }).toLowerCase()
            );
        },
        localSelected() {
            return this.selected;
        },
        displayKilos: {
            get() {
                const kilos = this.localSelected.kilos;
                return typeof kilos === 'number' ? kilos.toFixed(2) : kilos;
            },
            set(value) {
                this.localSelected.kilos = value;
            }
        },
        useWeight() {
            return this.checkFeature('conf_UseCheeseWeights');
        },
        setSize() {
            return this.useWeight ? 'width: 33%' : 'width: 50%';
        },
        isValid() {
            return (
                this.localSelected.amount > 0 &&
                this.localSelected.vormID > 0 &&
                this.localSelected.stocklocationID > 0
            );
        },
        isNormaal() {
            return this.selected.uitvalProductID == undefined;
        },
        maakTekst() {
            return Helper.stringformat(
                '{0}- {1} ' +
                    this.$t('prod_kooi', { ns: 'production' }).toLowerCase() +
                    ' {2}:{3}',
                this.selected.productNaam,
                this.selected.vormNaam,
                this.selected.kooi ? this.selected.kooi : '',
                this.selected.laag ? this.selected.laag : ''
            );
        }
    },
    methods: {
        setSizeVal(val) {
            return Helper.stringformat('width: {0} %', val);
        },
        checkFeature(feature) {
            const key = Feature.enum(feature);
            return this.$root.handleFeature(key);
        },
        forceRefesh() {
            this.localSelected.uitpekelTijdOri = this.selected.uitpekelTijdOri;
            this.localSelected.uitpekelTijd =
                DateHelper.convertedToDateTimeString(
                    this.selected.uitpekelTijd
                );
            this.setTijd();
            this.$forceUpdate();
        },
        set_input: function () {
            this.localSelected.isChanged = true;
            console.log('set_input', this.localSelected);
            this.$emit('validComponent', this.isValid);
            this.$emit('change', true);
            this.$emit('input', this.localSelected);
        },
        setPekeltijd() {
            if (this.localDate && this.localTijd) {
                const dateTime = DateHelper.DateFromInput(
                    this.localDate,
                    this.localTijd
                );
                this.localSelected.uitpekelTijdOri = dateTime;
                this.localSelected.uitpekelTijd =
                    DateHelper.convertedToDateTimeString(dateTime);
                this.aangeraakt += 1;
                this.set_input();
            }
        },
        set_inputTijd(value) {
            const tijd =
                this.localSelected.uitpekelTijdOri ??
                this.baseDateTime ??
                new Date();
            this.localSelected.uitpekelTijd =
                DateHelper.convertedFromTimepicker(tijd, value);
            this.localSelected.uitpekelTijdOri =
                this.localSelected.uitpekelTijd;
            this.set_input();
        },
        set_inputUitpekeltijd(value) {
            if (DateHelper.dateIsValid(value)) {
                this.localSelected.uitpekelTijdOri = value;
                this.localSelected.uitpekelTijd =
                    DateHelper.convertedToTime(value);
                this.aangeraakt += 1;
                this.set_input();
            }
        },
        setTijd() {
            this.datumtijd =
                this.localSelected.uitpekelTijdOri ??
                this.baseDateTime ??
                new Date();
            this.localDate = DateHelper.DateForInput(
                this.datumtijd,
                true,
                false
            );
            this.localTijd = this.localSelected.uitpekelTijdOri
                ? DateHelper.DateForInput(this.datumtijd, false, true)
                : DateHelper.DateForInput(new Date(), false, true);
            if(this.useTimeInput){
                this.setPekeltijd();
            } else{
                this.set_inputTijd(this.localTijd);
            }
        }
    },
    mounted() {
        this.localAmount = this.selected.amount;
        this.setTijd();
    },
    created() {}
};
</script>

<style scoped></style>
